var _rect, _rect2, _path, _rect3, _path2, _rect4, _path3, _path4, _path5, _rect5, _path6, _rect6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCercleSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 526,
    height: 86,
    viewBox: "0 0 526 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 526,
    height: 86,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 11,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#1877F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.1191 44.3234H86.8156L87.71 38.5013H81.1179V35.3192C81.1179 32.9005 81.9034 30.7558 84.1521 30.7558H87.7656V25.675C87.1307 25.5887 85.788 25.3999 83.2508 25.3999C77.9528 25.3999 74.8467 28.2148 74.8467 34.628V38.5013H69.4004V44.3234H74.8467V60.326C75.9253 60.4892 77.0178 60.5999 78.1393 60.5999C79.153 60.5999 80.1424 60.5067 81.1191 60.3738V44.3234Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 11,
    width: 64,
    height: 64,
    rx: 32,
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M173.732 40.7871L184.453 28.5923H181.913L172.603 39.1809L165.168 28.5923H156.592L167.836 44.6041L156.592 57.3923H159.133L168.964 46.2104L176.816 57.3923H185.392L173.731 40.7871H173.732ZM170.252 44.7452L169.113 43.1508L160.048 30.4638H163.951L171.266 40.7026L172.405 42.297L181.914 55.6059H178.011L170.252 44.7458V44.7452Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 11,
    width: 64,
    height: 64,
    rx: 32,
    fill: "url(#paint0_radial_12811_2045)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M263 29.8916C267.241 29.8916 267.819 29.8916 269.554 29.8916C271.096 29.8916 271.867 30.2771 272.446 30.4699C273.217 30.8554 273.795 31.0482 274.373 31.6265C274.952 32.2048 275.337 32.7831 275.53 33.5542C275.723 34.1325 275.916 34.9036 276.108 36.4458C276.108 38.1807 276.108 38.5663 276.108 43C276.108 47.4337 276.108 47.8193 276.108 49.5542C276.108 51.0964 275.723 51.8675 275.53 52.4458C275.145 53.2169 274.952 53.7952 274.373 54.3735C273.795 54.9518 273.217 55.3374 272.446 55.5301C271.867 55.7229 271.096 55.9157 269.554 56.1084C267.819 56.1084 267.434 56.1084 263 56.1084C258.566 56.1084 258.181 56.1084 256.446 56.1084C254.904 56.1084 254.133 55.7229 253.554 55.5301C252.783 55.1446 252.205 54.9518 251.627 54.3735C251.048 53.7952 250.663 53.2169 250.47 52.4458C250.277 51.8675 250.084 51.0964 249.892 49.5542C249.892 47.8193 249.892 47.4337 249.892 43C249.892 38.5663 249.892 38.1807 249.892 36.4458C249.892 34.9036 250.277 34.1325 250.47 33.5542C250.855 32.7831 251.048 32.2048 251.627 31.6265C252.205 31.0482 252.783 30.6627 253.554 30.4699C254.133 30.2771 254.904 30.0843 256.446 29.8916C258.181 29.8916 258.759 29.8916 263 29.8916ZM263 27C258.566 27 258.181 27 256.446 27C254.711 27 253.554 27.3855 252.59 27.7711C251.627 28.1566 250.663 28.7349 249.699 29.6988C248.735 30.6627 248.349 31.4337 247.771 32.5904C247.386 33.5542 247.193 34.7108 247 36.4458C247 38.1807 247 38.759 247 43C247 47.4337 247 47.8193 247 49.5542C247 51.2892 247.386 52.4458 247.771 53.4096C248.157 54.3735 248.735 55.3374 249.699 56.3012C250.663 57.2651 251.434 57.6506 252.59 58.2289C253.554 58.6145 254.711 58.8072 256.446 59C258.181 59 258.759 59 263 59C267.241 59 267.819 59 269.554 59C271.289 59 272.446 58.6145 273.41 58.2289C274.373 57.8434 275.337 57.2651 276.301 56.3012C277.265 55.3374 277.651 54.5663 278.229 53.4096C278.614 52.4458 278.807 51.2892 279 49.5542C279 47.8193 279 47.241 279 43C279 38.759 279 38.1807 279 36.4458C279 34.7108 278.614 33.5542 278.229 32.5904C277.843 31.6265 277.265 30.6627 276.301 29.6988C275.337 28.7349 274.566 28.3494 273.41 27.7711C272.446 27.3855 271.289 27.1928 269.554 27C267.819 27 267.434 27 263 27Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M263 34.7108C258.373 34.7108 254.711 38.3735 254.711 43C254.711 47.6265 258.373 51.2892 263 51.2892C267.627 51.2892 271.289 47.6265 271.289 43C271.289 38.3735 267.627 34.7108 263 34.7108ZM263 48.3976C260.108 48.3976 257.602 46.0843 257.602 43C257.602 40.1084 259.916 37.6024 263 37.6024C265.892 37.6024 268.398 39.9157 268.398 43C268.398 45.8916 265.892 48.3976 263 48.3976Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M271.482 36.4458C272.547 36.4458 273.41 35.5827 273.41 34.5181C273.41 33.4534 272.547 32.5904 271.482 32.5904C270.417 32.5904 269.554 33.4534 269.554 34.5181C269.554 35.5827 270.417 36.4458 271.482 36.4458Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 11,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#2878B7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M370.2 44.7084V55.2986H364.001V45.3541C364.001 42.9003 363.097 41.2213 360.902 41.2213C359.223 41.2213 358.19 42.3837 357.802 43.4169C357.673 43.8043 357.544 44.3209 357.544 44.9667V55.2986H351.345C351.345 55.2986 351.474 38.5092 351.345 36.8303H357.544V39.4133C358.319 38.1218 359.869 36.3137 363.097 36.3137C367.101 36.3137 370.2 39.0258 370.2 44.7084ZM344.887 27.9189C342.821 27.9189 341.4 29.3396 341.4 31.1477C341.4 32.9558 342.692 34.3764 344.758 34.3764C346.954 34.3764 348.245 32.9558 348.245 31.1477C348.374 29.2104 347.083 27.9189 344.887 27.9189ZM341.788 55.2986H347.987V36.8303H341.788V55.2986Z",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 11,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F40000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433.02 54.2909C432.393 54.1052 431.82 53.7749 431.351 53.3278C430.881 52.8807 430.529 52.3299 430.324 51.722C429.149 48.5798 428.801 35.4591 431.063 32.8689C431.816 32.0263 432.879 31.5075 434.021 31.4252C440.089 30.7883 458.836 30.8732 460.989 31.6375C461.595 31.8293 462.148 32.1524 462.608 32.5826C463.067 33.0128 463.421 33.5389 463.643 34.1215C464.926 37.3699 464.97 49.1743 463.469 52.2952C463.071 53.1076 462.404 53.7657 461.577 54.1635C459.315 55.2675 436.022 55.2463 433.02 54.2909V54.2909ZM442.655 48.1339L453.53 42.6139L442.655 37.0514V48.1339Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_12811_2045",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(296.287 12.3) scale(147.795)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9ED32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#EE2A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#D22A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#8B2AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#1B2AF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#002AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCercleSocial);
export default __webpack_public_path__ + "static/media/CercleSocial.bb8d6dcc6b51c8e8aa0c11f33baf4ea0.svg";
export { ForwardRef as ReactComponent };